// extracted by mini-css-extract-plugin
export default {"pathWrapper":"uIALi1ZJ"};